// Menu styling is a per-page Sanity setting; clear it on every navigation so it
// never leaks onto pages without one (product, search, checkout, ...).
export default defineNuxtRouteMiddleware(() => {
    const menuStyling = useMenuStyling();
    menuStyling.value = null;
});
